import { esc, DOC_STYLES, docHeader, signatureBlock, makeDocNo, elementToPdf } from "./pdfCommon";

export async function downloadTransactionsPdf({ t, fmt, rows, from, to, userName }) {
  const docNo = makeDocNo("IRF");
  const inc = rows.filter((r) => r.type === "income").reduce((s, r) => s + r.amount, 0);
  const exp = rows.filter((r) => r.type === "expense").reduce((s, r) => s + r.amount, 0);
  const period = [from, to].filter(Boolean).join(" — ") || "";

  const body = rows.map((r) => `<tr>
    <td style="${DOC_STYLES.td};font-family:'JetBrains Mono',monospace;font-size:10.5px;white-space:nowrap">${esc(r.date)}</td>
    <td style="${DOC_STYLES.td}"><span style="color:${r.type === "income" ? "#059669" : "#DC2626"};font-weight:600">${r.type === "income" ? esc(t.app.income) : esc(t.app.expense)}</span></td>
    <td style="${DOC_STYLES.td}">${esc(r.category)}</td>
    <td style="${DOC_STYLES.td}">${esc(r.description || "—")}</td>
    <td style="${DOC_STYLES.td}">${esc(r.cari_name || "—")}</td>
    <td style="${DOC_STYLES.tdNum};color:${r.type === "income" ? "#059669" : "#DC2626"}">${r.type === "income" ? "+" : "−"}${fmt(r.amount)}</td>
  </tr>`).join("");

  const box = (label, value, color) =>
    `<div style="flex:1;border:1px solid #E2E8F0;border-radius:10px;padding:12px 16px">
      <div style="font-size:9px;color:#94A3B8;text-transform:uppercase;letter-spacing:1px">${label}</div>
      <div style="margin-top:4px;font-size:16px;font-weight:700;color:${color};font-family:'JetBrains Mono',monospace">${value}</div>
    </div>`;

  const html = `
    ${docHeader(t.doc.title, period)}
    <div style="margin-top:18px;display:flex;gap:10px">
      ${box(t.rep.totalIncome, fmt(inc), "#059669")}
      ${box(t.rep.totalExpense, fmt(exp), "#DC2626")}
      ${box(t.rep.totalNet, fmt(inc - exp), "#0F172A")}
      ${box(t.doc.records, String(rows.length), "#0F172A")}
    </div>
    <table style="width:100%;border-collapse:collapse;margin-top:20px">
      <tr>
        <th style="${DOC_STYLES.th}">${esc(t.app.date)}</th>
        <th style="${DOC_STYLES.th}">${esc(t.app.income)}/${esc(t.app.expense)}</th>
        <th style="${DOC_STYLES.th}">${esc(t.app.category)}</th>
        <th style="${DOC_STYLES.th}">${esc(t.app.description)}</th>
        <th style="${DOC_STYLES.th}">${esc(t.app.cari)}</th>
        <th style="${DOC_STYLES.thNum}">${esc(t.app.amount)}</th>
      </tr>
      ${body}
    </table>
    ${signatureBlock({ docNo, userName, t })}
  `;
  await elementToPdf(html, `ira-finans-islem-dokumu-${new Date().toISOString().slice(0, 10)}.pdf`);
}
